const providersSocial = [
  {
    index: 1,
    date: "09/12/2018",
    name: "Cheryl Deggins",
    clinic: "Trinity Health"
  },
  {
    index: 2,
    date: "08/11/2018",
    name: "Sam Smith",
    clinic: "Bethesda House"
  },
];

export default providersSocial;
